import { styled } from '@mui/material/styles'

const HiddenDesktop = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'none'
  }
}))

export default HiddenDesktop
